import { styled, FormControl as FormControl$1, formControlLabelClasses, radioClasses, svgIconClasses, FormLabel as FormLabel$1, formLabelClasses, checkboxClasses } from "@mui/material";
const FormControl = styled(FormControl$1)(({ error, theme }) => ({
  [`& .${formControlLabelClasses.root}`]: {
    width: "100%"
  },
  [`& .${formControlLabelClasses.label}`]: {
    color: error ? theme.palette.error[500] : theme.palette.grey[800]
  },
  [`& .${radioClasses.root} .${svgIconClasses.root}`]: {
    color: error ? theme.palette.error[500] : "currentColor"
  }
}));
const FormLabel = styled(FormLabel$1)(({ theme, required }) => ({
  ...theme.typography["Lato Caption"],
  color: theme.palette.grey[800],
  marginLeft: theme.spacing(2),
  marginBottom: 2,
  [`& .${formLabelClasses.asterisk}`]: {
    display: "none"
  },
  "&.Mui-error": {
    color: theme.palette.error[500]
  },
  "&.Mui-focused:not(.Mui-error)": {
    color: theme.palette.grey[800]
  },
  "&::before": {
    content: required ? "'*'" : void 0,
    color: theme.palette.error[500]
  }
}));
const CheckboxContainer = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  padding: theme.spacing(1.5, 2),
  borderRadius: "4px 4px 0 0",
  "&:not(:first-child)": {
    borderTop: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: 0
  },
  [`& .${formControlLabelClasses.root}`]: {
    justifyContent: "flex-start",
    margin: 0
  },
  [`& .${checkboxClasses.root}`]: {
    marginLeft: -9,
    marginTop: -9,
    marginBottom: -9
  }
}));
const InputContainer = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  padding: theme.spacing(1.5, 2),
  borderBottom: `1px solid ${theme.palette.grey[300]}`,
  display: "flex",
  "&:last-of-type": {
    borderRadius: "4px 4px 0 0",
    borderTop: 0,
    marginTop: theme.spacing(1)
  },
  "&:first-of-type:not(:last-of-type)": {
    borderTop: `1px solid ${theme.palette.grey[300]}`
  },
  "&:focus-within": {
    borderBottomColor: theme.palette.primary.main,
    borderBottomWidth: 2
  },
  [`& ${checkboxClasses.root}`]: {
    marginLeft: -9
  }
}));
const Input = styled("input")(({ theme }) => ({
  minHeight: 48,
  marginTop: theme.spacing(-1.5),
  marginBottom: theme.spacing(-1.5),
  width: "100%",
  border: "none",
  fontSize: "17px",
  fontFamily: theme.typography.fontFamily,
  letterSpacing: 0.5,
  color: theme.palette.grey[800],
  backgroundColor: "transparent",
  "&:focus": {
    outline: "none"
  }
}));
export {
  CheckboxContainer,
  FormControl,
  FormLabel,
  Input,
  InputContainer
};
